import React, { useState, useEffect } from 'react'

export const LanguageContext = React.createContext()

export function LanguageContextProvider (props) {
  const defaultLanguage = navigator.language || navigator.userLanguage
  const [locale, setLocale] = useState(defaultLanguage.substring(0, 2))
  const acceptLanguageArray = {
    zh: 'zh-CN,zh;q=0.9',
    en: 'en-US,en;q=0.9'
  }
  const [acceptLanguage, setAccpetLanguage] = useState(acceptLanguageArray[defaultLanguage.substring(0, 2)])
  useEffect(() => {
    setAccpetLanguage(acceptLanguageArray[locale])
  }, [locale])
  return (
    <LanguageContext.Provider value={{ locale, setLocale, acceptLanguage }}>
      {props.children}
    </LanguageContext.Provider>
  )
}
